"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconInfo = void 0;
const enums_1 = require("./enums");
const getIconInfo = (collection, id, kind) => {
    let res = null;
    if (id) {
        const idMinus = id.toLowerCase();
        const kindMinus = kind.toLowerCase() || 'm';
        if (enums_1.ICON_INFO[collection] &&
            enums_1.ICON_INFO[collection][idMinus] &&
            enums_1.ICON_INFO[collection][idMinus][kindMinus]) {
            return {
                collection: `${collection}`,
                content: enums_1.ICON_INFO[collection][idMinus][kindMinus],
            };
        }
        const groups = Object.keys(enums_1.ICON_INFO);
        groups.forEach((group) => {
            if (res) {
                return res;
            }
            if (group !== collection &&
                enums_1.ICON_INFO[group][idMinus] &&
                enums_1.ICON_INFO[group][idMinus][kindMinus]) {
                res = {
                    collection: group,
                    content: enums_1.ICON_INFO[group][idMinus][kindMinus],
                };
            }
        });
    }
    return res;
};
exports.getIconInfo = getIconInfo;
//# sourceMappingURL=utils.js.map